import { useTranslation } from 'react-i18next';
import { Dispatch, SetStateAction } from 'react';

import { Button, Modal, ModalInner } from 'components';
import { SpaceCraftDetailData } from './types';
import axios from 'common/AxiosAuth';

interface ModalProps {
  data: SpaceCraftDetailData | null;
  setData: Dispatch<SetStateAction<SpaceCraftDetailData | null>>;
  onDeleted: () => void;
  setIsDeleteModalOpened: Dispatch<SetStateAction<boolean>>;
}

const DetailDeleteModal = ({ data, setData , onDeleted, setIsDeleteModalOpened}: ModalProps) => {
  const { t } = useTranslation();
  const onDelete = async () => {
    if (data && data.id) {
      try {
        await axios.delete(`/api/link/${data.id}`);
        setIsDeleteModalOpened(false);
        setData(null);
        onDeleted();
      } catch (error: any) {
        console.error('삭제 중 에러 발생:', error.response ? error.response.data : error.message);
      }
    } else {
      console.error('삭제할 데이터가 없거나 ID가 없습니다.');
    }
  };

  const onCancel = () => {
    setIsDeleteModalOpened(false);
  };


  return (
    <Modal isOpened={!!data}>
      <ModalInner className="md:w-[400px]" title={t('manage.modal.deleteTitle')} onClickClose={onCancel}>
        <p className="p-4 pt-0 text-body1">{t('manage.modal.deleteMessage')}</p>
        <div className="flex w-full flex-row items-center justify-between bg-bg-transparent_gray_light p-4">
          <Button className="h-9" text={t('manage.button.cancel')} onClick={onCancel} type="secondary" size="large" />
          <Button className="h-9 bg-red-600 border-red-600" text={t('manage.button.delete')} onClick={onDelete} type="blue" size="large" />
        </div>
      </ModalInner>
    </Modal>
  );
};

export default DetailDeleteModal;
